import { render, staticRenderFns } from "./jdcpscatemanagent.vue?vue&type=template&id=71374f34&scoped=true&"
import script from "./jdcpscatemanagent.vue?vue&type=script&lang=js&"
export * from "./jdcpscatemanagent.vue?vue&type=script&lang=js&"
import style0 from "./jdcpscatemanagent.vue?vue&type=style&index=0&id=71374f34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71374f34",
  null
  
)

export default component.exports